"use client";
import Modal from "@/components/Modal";
import { useState } from "react";
import { useTranslations } from "next-intl";

const TypesOfConsumers = ({ messages }) => {
  const t = useTranslations("TypesOfCunsumerPage");
  const consumerTypes = messages.TypesOfCunsumerPage.consumerTypes;
  const consumerDescriptions = messages.TypesOfCunsumerPage.consumerDescriptions;
  const [popup, setPopup] = useState("");

  return (
    <main className="bg-green-8 h-[94%] py-4 px-4 rounded-lg">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-10 text-green-2">
          {t("title")}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
          {consumerTypes.map((type,index) => (
            <div
              onClick={() => setPopup(type)}
              key={index}
              className="relative bg-white shadow rounded-md p-4 hover:bg-green-11  group border hover:shadow-md hover:transform hover:transition-all hover:duration-300 hover:scale-110 h-32 rounded-br-2xl cursor-pointer hover:motion hover:border-green-12"
            >
              <p className="text-gray-700 font-medium py-4 group-hover:font-semibold group-hover:text-white">
                {type}
              </p>
              <div className="absolute bottom-0 right-0 w-12 h-12 bg-green-2 text-white flex items-center justify-center text-lg font-bold rounded-tl-2xl rounded-br-2xl">
                +
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-center mt-10">
          {/* <div className="bg-[#d5e6ff] text-green-1 py-2 px-8 rounded-full text-lg font-semibold shadow">
            {t("ltConsumer")}
          </div> */}
        </div>
      </div>

      <Modal isOpen={!!popup} onClose={() => setPopup("")}>
        <div className="w-[450px] lg:w-[800px] 2xl:w-[1000px] min-h-[100px] lg:max-h-[500px] 2xl:max-h-[700px] bg-white rounded-xl overflow-y-auto justify-center items-center p-6">
          <h2 className="font-bold text-center text-lg text-green-1 mb-2">
            {popup}
          </h2>
          {(() => {
            const index = consumerTypes.indexOf(popup);
            const description = consumerDescriptions[index];
            return description
              ?.split("\n")
              .filter((p) => p.trim() !== "")
              .map((paragraph, idx) => (
                <p
                  key={idx}
                  className="text-gray-700 font-medium mb-3 text-justify"
                >
                  {paragraph}
                </p>
              ));
          })()}
        </div>
      </Modal>
    </main>
  );
};
export default TypesOfConsumers;
